export default class TemplateService {
  constructor(server){
    this.server = server;
  }

  send(template, email, projektId, uzivatelId){
    return this.server("templateSend", {
      template: template,
      email: email,
      projektId: projektId,
      uzivatelId: uzivatelId
    })
  }

  downloadUrl(template, projektId){
    return this.server.getRequestUrl("templateDownload", {template: template, projektId: projektId});
  }

}


// WEBPACK FOOTER //
// ./src/services/TemplateService.js